module.exports = __webpack_public_path__ + "media/customizations/riverland/logo-new-9f536ab99ae39c118aa38e5162b74b0b.png";